import { useAppDispatch } from '../../../../base';
import { JobStatus } from '../../../../common';
import { jobsActions } from '../../../../actions';

export const useStatusMenu = () => {
    const dispatch = useAppDispatch();

    const onChangeStatus = (id: number | undefined, status: JobStatus) => {
        if (!id) return;
        const updateJobActionPayload = {
            jobId: String(id),
            status,
        };
        dispatch(jobsActions.updateJobStatus(updateJobActionPayload));
    };

    const onEdit = (id: number | undefined) =>
        console.log(`edit ${id} clicked`);

    const onClone = (id: number | undefined) => {
        if (!id) return;
        console.log(`clone ${id} clicked`);
    };

    const onMenuItemClick = (
        id: number | undefined,
        actionId: string | undefined
    ) => {
        switch (actionId) {
            case JobStatus.Published:
                onChangeStatus(id, JobStatus.Published);
                break;
            case JobStatus.Suspended:
                onChangeStatus(id, JobStatus.Suspended);
                break;
            case JobStatus.Completed:
                dispatch(
                    jobsActions.setCancelOrCloseJob({
                        jobId: String(id),
                        status: JobStatus.Completed,
                    })
                );
                dispatch(jobsActions.setConfirmJobCloseOrCancelModalOpen(true));
                break;
            case JobStatus.Canceled:
            case JobStatus.Closed:
                dispatch(
                    jobsActions.setCancelOrCloseJob({
                        jobId: String(id),
                        status: JobStatus.Canceled,
                    })
                );
                dispatch(jobsActions.setConfirmJobCloseOrCancelModalOpen(true));
                break;
            default:
                break;
        }
    };

    return { onMenuItemClick };
};
